import React from "react"
import styled from "styled-components"
import { device } from "../../themes/device"
import icon_email from "../../images/icon_email.svg"
import icon_phone from "../../images/phone.svg"

const List = styled.ul`
  list-style-type: none;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0;
  margin-bottom: 32px;

  @media ${device.tablet} {
    justify-content: space-around;
  }
`

const Link = styled.a`
  text-decoration: none;
  color: black;
  font-weight: bold;
`

const Main = () => {
  return (
    <List>
      <li>
        <Link href="mailto:info@codeflow.ch">
          {" "}
          <img style={{ height: "32px" }} src={icon_email} /> <br />
          info@codeflow.ch
        </Link>
      </li>
      <li>
        <Link href="tel:+41791792727">
          <img style={{ height: "32px" }} src={icon_phone} /> <br />
          079 179 27 27
        </Link>
      </li>{" "}
    </List>
  )
}

export default Main
